export const cleanMapCoor = (coors) => {
    let firstNumber = coors[0].LONGITUDE;
    let updated = coors.map(val => {
      if (firstNumber > 0) {
        return val.LONGITUDE < 0 ? { ...val, LONGITUDE: String(Number(val.LONGITUDE) + 360) } : val;
      } else if (firstNumber < 0) {
        return val.LONGITUDE > 0 ? { ...val, LONGITUDE: String(Number(val.LONGITUDE) - 360) } : val;
      }
      return val;
    });
    return updated
  }